<template>
  <div class="cmp-switch-cont" @click="$emit('input', !value)">
    <div class="cmp-switch-cont">
      <div class="cmp-switch" :class="{ 'cmp-active': value }">
        <div></div>
      </div>
    </div>
    <i :class="icon" v-if="icon" :title="icon_hint" class="js-tooltip" />
    <label :title="label" v-if="label" :class="{ multiline }">{{ label }}</label>
  </div>
</template>
<script>
export default {
  name: 'SwitchComponent',
  props: {
    value: { type: Boolean, default: false },
    label: { type: String },
    icon: { type: String },
    icon_hint: { type: String },
    isCircled: { type: Boolean, default: false },
    multiline: { type: Boolean, default: false },
  },
};
</script>
<style scoped>
.cmp-switch-cont {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.cmp-switch {
  background: #adadad;
  padding: 2px 2px;
  border-radius: 25px;
  width: 28px;
  display: inline-flex;
  justify-content: flex-start;
  vertical-align: top;
  flex-shrink: 0;
}
.cmp-switch > div {
  display: block;
  width: 15px;
  height: 15px;
  background: #fff;
  border-radius: 15px;
}
.cmp-active {
  justify-content: flex-end;
  background: #7ab982;
}
.cmp-switch-cont {
  padding: 2px;
  border: 2px solid #fff0;
}
.cmp-is-circled {
  border-radius: 15px;
  border: 2px solid #61a9ff;
}
label {
  margin-left: 10px;
  word-break: break-word;
}
.multiline {
  white-space: nowrap;
}
</style>
